export enum VmTypes {
  None,
  EVM,
  Cardano,
}
